import React from 'react';
import {entity as mmsSnippets} from '../../ducks/mmsSnippets';
import SnippetList from './SnippetList';
import MMSSnippetEditor from './MMSSnippetEditor';
import {tags} from "../../ducks";
import {withSnippetFunctions} from "./snippetUtils";
import {compose} from "redux";
import {withRouter} from "react-router";
import withFiltering from "../../hocs/withFiltering";
import duckify, {filterDuck} from "../../utils/duckify";
import withTagging from "../../hocs/withTagging";

const MMSSnippetList = (props) => {
  return <SnippetList
    displayName="Text Message"
    editModal={MMSSnippetEditor}
    type="mms"
    {...props}
  />;
}

const mapDucksToProps = ({filters}) => ({
  items: filterDuck(mmsSnippets, {filters}),
  tags,
});

export default compose(
  withRouter,
  withFiltering,
  withTagging(mmsSnippets),
  withSnippetFunctions(mmsSnippets),
  duckify(mapDucksToProps)
)(MMSSnippetList);
